import { adminAxiosInstance } from "./adminAxiosInstance";
import { getMarketPricesMeta } from "./marketPricesMeta";

const endpoint = "/admin/internal/ops/market-prices";
const requireSuccess = (response, fallback) => {
  if (response?.status === false) throw new Error(response?.message || fallback);
  return response;
};

export const getMarketPriceMeta = () => getMarketPricesMeta({ admin: true });

export const createMarketPrice = async (entry) => {
  const { data } = await adminAxiosInstance.post(endpoint, entry);
  return requireSuccess(data, "Market price could not be saved.");
};

export const createBulkMarketPrices = async (payload) => {
  const { data } = await adminAxiosInstance.post(`${endpoint}/bulk`, payload);
  return requireSuccess(data, "Market prices could not be saved.");
};

export const updateMarketPrice = async (priceEntryId, entry) => {
  const { data } = await adminAxiosInstance.patch(`${endpoint}/${encodeURIComponent(priceEntryId)}`, entry);
  return requireSuccess(data, "Market price entry could not be updated.");
};

export const getMarketPriceHistory = async (options = {}) => {
  const params = Object.fromEntries(Object.entries(options).filter(([, value]) => value !== undefined && value !== null && value !== ""));
  const { data } = await adminAxiosInstance.get(endpoint, { params });
  return requireSuccess(data, "Market price history could not be loaded.");
};

export const deleteMarketPrice = async (priceEntryId) => {
  const { data } = await adminAxiosInstance.delete(`${endpoint}/${encodeURIComponent(priceEntryId)}`);
  return requireSuccess(data, "Market price entry could not be deleted.");
};
